import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    model: {},
    plans: [],
    quotationContact: null,
    schemaSelected: null,
    process_id: null,
};

export const selectionSlice = createSlice({
    name: "selection2D",
    initialState,
    reducers: {
        setModel(state, action) {
            state.model = action.payload;
        },
        setSchemaPlans(state, action) {
            state.plans = action.payload;
        },
        setQuotationContact(state, action) {
            state.quotationContact = action.payload;
        },
        setSchemaSelected(state, action) {
            state.schemaSelected = action.payload;
        },
        setProcess_id(state, action) {
            state.process_id = action.payload;
        },
    },
});

export const { setModel, setSchemaPlans, setQuotationContact, setSchemaSelected, setProcess_id } =
    selectionSlice.actions;
export default selectionSlice.reducer;
